export default __webpack_public_path__ + "static/media/rotate_backwards.2ef268f1.svg";